import React, { useEffect, useState } from 'react';
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import useHttp from "../../../hook/use-http";
import ChartLoader from "./ChartLoader";
import WaterMark from "../DashboardMain_Orion/WaterMark";
import './CriticalCustom_Orion.css';
import { max } from 'moment';
import NoData from './NoData';

export default function CriticalTableSection_Orion({gloablfilter, maxPackIndex}) {

    const { isLoading, error, sendReq: fetchData } = useHttp();
    const [topselected, setTopSelected] = useState('table1');
    const [greaterThanFortyAPack, setGreaterThanFortyAPack] = useState(0);
    const [greaterThanFortyBPack, setGreaterThanFortyBPack] = useState(0);
    const [greaterThanFortyCPack, setGreaterThanFortyCPack] = useState(0);
    const [greaterThanFortyDPack, setGreaterThanFortyDPack] = useState(0);
    const [maxcellA, setMaxcellA] = useState(0);
    const [maxcellB, setMaxcellB] = useState(0);
    const [maxcellC, setMaxcellC] = useState(0);
    const [maxcellD, setMaxcellD] = useState(0);
    const [bucketA, setBucketA] = useState("");
    const [bucketB, setBucketB] = useState("");
    const [bucketC, setBucketC] = useState("");
    const [bucketD, setBucketD] = useState("");


    useEffect(() => {
      setBucketA(findbucket(maxPackIndex[0]))
      setBucketB(findbucket(maxPackIndex[1]))
      setBucketC(findbucket(maxPackIndex[2]))
      setBucketD(findbucket(maxPackIndex[3]))
    }, [maxPackIndex]);

    const findbucket = (index) =>{
      if (index === null || index === "null") {
        return("-")
      }else if(index === 0){
        return("0 - 26")
      }else if(index === 1){
        return("26 - 28")
      }else if(index === 2){
        return("28 - 30")
      }
      else if(index === 3){
        return("30 - 32")
      }
      else if(index === 4){
        return("32 - 34")
      }
      else if(index === 5){
        return("34 - 36")
      }
      else if(index === 6){
        return("36 - 38")
      }
      else if(index === 7){
        return("38 - 40")
      }
      else if(index === 8){
        return("40 - 42")
      }else{
        return(">42")
      }
    }

    const toppChange = (e) =>{
        setTopSelected(e.target.value);
    }

    useEffect(() => {
        fetchData({ url: API_URL_MAIN + "critical_vehicles_orion_fleet/critcal_greaterthanfortyTable", body: { filterdata: gloablfilter, packType: "A_Max_Cell_Temp"} }, critical_responseA)
        fetchData({ url: API_URL_MAIN + "critical_vehicles_orion_fleet/critcal_greaterthanfortyTable", body: { filterdata: gloablfilter, packType: "B_Max_Cell_Temp"} }, critical_responseB)
        fetchData({ url: API_URL_MAIN + "critical_vehicles_orion_fleet/critcal_greaterthanfortyTable", body: { filterdata: gloablfilter, packType: "C_Max_Cell_Temp"} }, critical_responseC)
        fetchData({ url: API_URL_MAIN + "critical_vehicles_orion_fleet/critcal_greaterthanfortyTable", body: { filterdata: gloablfilter, packType: "D_Max_Cell_Temp"} }, critical_responseD)
        fetchData({ url: API_URL_MAIN + "critical_vehicles_orion_fleet/critcal_MaxCellTempTable", body: { filterdata: gloablfilter} }, critcal_MaxCellTable)
    }, [gloablfilter, topselected])

    const critical_responseA = (data) =>{
        setGreaterThanFortyAPack(data.value)
    }
    const critical_responseB = (data) =>{
        setGreaterThanFortyBPack(data.value)
    }
    const critical_responseC = (data) =>{
        setGreaterThanFortyCPack(data.value)
    }
    const critical_responseD = (data) =>{
        setGreaterThanFortyDPack(data.value)
    }

    const critcal_MaxCellTable = (data) =>{
      // setMaxcellA(data[0].A_Max_Cell_Temp.value)
      // setMaxcellB(data[0].B_Max_Cell_Temp.value)
      // setMaxcellC(data[0].C_Max_Cell_Temp.value)
      // setMaxcellD(data[0].D_Max_Cell_Temp.value)
      setMaxcellA((data[0].A_Max_Cell_Temp.value !== null) ? data[0].A_Max_Cell_Temp.value : '-' )
      setMaxcellB((data[0].B_Max_Cell_Temp.value !== null) ? data[0].B_Max_Cell_Temp.value : '-' )
      setMaxcellC((data[0].C_Max_Cell_Temp.value !== null) ? data[0].C_Max_Cell_Temp.value : '-' )
      setMaxcellD((data[0].D_Max_Cell_Temp.value !== null) ? data[0].D_Max_Cell_Temp.value : '-' )
    }

  return (
    <>
        <div className="chargingChartboxNew2_Bus">
          <div className="v-title chargingTitleChart_Bus_fleet">
          <div className="row ml-3">
          <div className="col-md-12 py-1" >
            <div className="form-check form-check-inline bus" style={{ fontSize: '12px' }}>
              <input
                className="form-check-input"
                type="radio"
                name="inlineRadioOptionsnew1"
                id="table1"
                value="table1"
                checked={topselected === "table1"}
                onChange={toppChange}
              />
              <label className="form-check-label" htmlFor="inlineRadio3">
              Max Cell Temp
              </label>
            </div>
            <div className="form-check form-check-inline bus" style={{ fontSize: '12px' }}>
              <input
                className="form-check-input"
                type="radio"
                name="inlineRadioOptionsnew2"
                id="table2"
                value="table2"
                checked={topselected === "table2"}
                onChange={toppChange}
              />
              <label className="form-check-label" htmlFor="inlineRadio4">
              &gt; 40 °(C)
              </label>
            </div>
          </div>
        </div>
          </div>

          <div className="table-container px-2 mt-5 pt-1">

            {
              (topselected === "table1") ? (maxcellA !==null || maxcellB !==null || maxcellC !==null || maxcellD !==null) ? 
              <table className="secondtable">
                <thead>
                    <tr>
                        <th>Pack</th>
                        <th>Max Cell Temp</th>
                        <th>Max Vin Bucket</th>
                    </tr>
                </thead>
                <tbody>
                    <tr><td>A</td><td>{maxcellA}</td><td>{bucketA}</td></tr>
                    <tr><td>B</td><td>{maxcellB}</td><td>{bucketB}</td></tr>
                    <tr><td>C</td><td>{maxcellC}</td><td>{bucketC}</td></tr>
                    <tr><td>D</td><td>{maxcellD}</td><td>{bucketD}</td></tr>
                </tbody>
              </table> : <NoData /> :
              (greaterThanFortyAPack != null || greaterThanFortyBPack !==null || greaterThanFortyCPack !==null || greaterThanFortyDPack !==null) ? 
              <table className="secondtable rounded">
                <thead>
                    <tr>
                        <th>Pack</th>
                        <th>Vehicle with max cell temp &gt; 40 </th>
                    </tr>
                </thead>
                <tbody>
                    <tr><td>A</td><td>{greaterThanFortyAPack}</td></tr>
                    <tr><td>B</td><td>{greaterThanFortyBPack}</td></tr>
                    <tr><td>C</td><td>{greaterThanFortyCPack}</td></tr>
                    <tr><td>D</td><td>{greaterThanFortyDPack}</td></tr>
                </tbody>
            </table> : <NoData />
            }
        </div>
        </div>
    </>
  )
}
